const responseTooLargeMessage = 'Response exceeded the maximum allowed size.';
const readStream = async (reader, decoder, limit, consumed = 0) => {
    const { done, value } = await reader.read();
    if (done) {
        return decoder.decode();
    }
    const nextConsumed = consumed + value.byteLength;
    if (nextConsumed > limit) {
        await reader.cancel();
        throw new Error(responseTooLargeMessage);
    }
    return (decoder.decode(value, { stream: true }) +
        (await readStream(reader, decoder, limit, nextConsumed)));
};
export const readBoundedResponseText = async (response, limit) => {
    const declaredLength = Number(response.headers.get('content-length'));
    if (Number.isFinite(declaredLength) && declaredLength > limit) {
        throw new Error(responseTooLargeMessage);
    }
    if (response.body) {
        return readStream(response.body.getReader(), new TextDecoder(), limit);
    }
    const text = await response.text();
    if (new TextEncoder().encode(text).byteLength > limit) {
        throw new Error(responseTooLargeMessage);
    }
    return text;
};
